/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
// chakra imports

export function SidebarLinks(props) {
  // Chakra color mode
  let location = useLocation();

  const { routes } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (
        (route.layout === "/admin" ||
          route.layout === "/client"
        ) && !route.hidden
      ) {
        const active = activeRoute(route.path);
        return (
          <Link key={index} to={route.layout + "/" + route.path}>
            <div className="relative mb-2 flex hover:cursor-pointer">
              <li
                className={`mx-4 my-[3px] flex w-full cursor-pointer items-center rounded-xl px-4 py-3 transition-all duration-200 ${active
                  ? "bg-brand-500/10 dark:bg-brand-400/10"
                  : "hover:translate-x-1 hover:bg-gray-100 dark:hover:bg-white/5"
                  }`}
                key={index}
              >
                <span
                  className={`text-lg transition-colors duration-200 ${active
                    ? "font-bold text-brand-500 dark:text-white"
                    : "font-medium text-gray-600 dark:text-gray-400"
                    }`}
                >
                  {route.icon ? route.icon : <DashIcon />}{" "}
                </span>
                <p
                  className={`leading-1 ml-4 flex transition-colors duration-200 ${active
                    ? "font-bold text-navy-700 dark:text-white"
                    : "font-medium text-gray-600 dark:text-gray-400"
                    }`}
                >
                  {route.name}
                </p>
              </li>
              {active ? (
                <div className="absolute right-0 top-1/2 h-8 w-1 -translate-y-1/2 animate-scaleIn rounded-l-lg bg-brand-500 dark:bg-brand-400" />
              ) : null}
            </div>
          </Link>
        );
      }
    });
  };
  // BRAND
  return createLinks(routes);
}

export default SidebarLinks;
